/*
 * @function: 监听页面返回
*/
const SHOW = 'show';
const HIDDEN = 'hidden';
function getPageStatus(status, cb) {
    let pageStatus = SHOW;
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            pageStatus = HIDDEN;
        }
        else {
            pageStatus = SHOW;
        }
        if (pageStatus === status) {
            cb();
        }
    });
    window.addEventListener('pagehide', () => {
        pageStatus = HIDDEN;
        if (pageStatus === status) {
            cb();
        }
    });
    window.addEventListener('pageshow', () => {
        pageStatus = SHOW;
        if (pageStatus === status) {
            cb();
        }
    });
}
function pageShow(cb) {
    getPageStatus(SHOW, cb);
}
class AnimationFrame {
    constructor() {
        this.stop = false;
        this.startTime = 0;
        this.callback = null;
    }
    moveAnimation() {
        if (!this.startTime) {
            this.startTime = Date.now();
        }
        else {
            const now = Date.now();
            const interval = now - this.startTime;
            if (interval < 500) {
                this.startTime = now;
            }
            else {
                this.startTime = now;
                if (this.callback) {
                    this.callback();
                }
            }
        }
        if (!this.stop) {
            window.requestAnimationFrame(this.moveAnimation.bind(this));
        }
    }
    startAnimation(cb) {
        if (this.startTime)
            return;
        try {
            this.stop = false;
            this.moveAnimation();
        }
        catch (_) {
            // 
        }
        if (cb) {
            this.callback = cb;
        }
    }
    stopAnimation() {
        try {
            this.stop = true;
            this.startTime = 0;
            this.callback = null;
        }
        catch (_) {
            // 
        }
    }
}
class PageShow {
    constructor() {
        this.showMap = {};
        this.animation = new AnimationFrame();
        this._init();
        this.showCbTime = 0;
    }
    _init() {
        pageShow(this._onShowCallBack.bind(this));
    }
    _onShowCallBack() {
        // 节流 时间为600ms， 防止同一时间触发多次
        const now = Date.now();
        if (!this.showCbTime) {
            this.showCbTime = now;
        }
        else if ((now - this.showCbTime) < 600) {
            return;
        }
        setTimeout(() => {
            this.showCbTime = 0;
        }, 700);
        for (const eventId in this.showMap) {
            this.showMap[eventId]();
        }
    }
    on(eventId, cb) {
        this.animation.startAnimation(this._onShowCallBack.bind(this));
        this.showMap[eventId] = cb;
    }
    remove(eventId) {
        this.animation.stopAnimation();
        if (this.showMap[eventId]) {
            delete (this.showMap[eventId]);
        }
    }
}
export default new PageShow();
